<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" icon="fa fa-paper-plane" title="Gửi tài liệu"/>
    <el-row v-if="show">
      <el-col :span="18" :offset="3">
        <el-form ref="form" label-width="160px" label-position="left">
          <el-form-item label="Tên tài liệu">
            <div class="document-title">{{ document.title }}</div>
          </el-form-item>
          <el-form-item label="Email chia sẻ">
            <el-input
              placeholder="Nhập Email muốn chia sẻ"
              v-model="email"
              @keyup.native.enter="startCheck"
              @keydown.native.tab="startCheck"
              v-click-outside="startCheck"
            >
              <i
                class="el-icon-success el-input__icon success-email-check-icn"
                slot="suffix"
                v-if="isStartCheck && isRealEmail"
              >
              </i>
              <i
                class="el-icon-error el-input__icon error-email-check-icn"
                slot="suffix"
                v-else-if="isStartCheck && !isRealEmail"
              >
              </i>
            </el-input>
          </el-form-item>
          <el-form-item label="Tên thư mục">
            <el-select v-model="folderName" :loading="loadingFolderName" placeholder="Chọn thư mục">
              <el-option v-for="item in optionsFolderName" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Mô tả" v-if="description.length !== 0">
            {{ description }}
          </el-form-item>
          <el-form-item label="Quyền" v-if="permissions.length !== 0">
            <el-tag v-for="item in permissions" :key="item" style="margin-right: 5px">
              {{ formatPermission(item) }}
            </el-tag>
          </el-form-item>

          <h5>Tài liệu đã được chia sẻ cho {{ document.sharedTags.length }} thư mục</h5>
          <div class="shared-tag-list" v-if="document.sharedTags.length > 0">
            <div
              class="shared-tag"
              :type="['default', 'success', 'info'][index % 3]"
              v-for="(tag, index) in orderedSharedTag"
              :key="tag.id"
              closable
            >
              {{ tag.name }} - {{ tag.userEmail }}
            </div>
            <el-button type="text" @click="detailSharedTag = true">Xem chi tiết thư mục đã chia sẻ... </el-button>
          </div>

          <el-row type="flex" class="dialog-footer" justify="end">
            <el-button @click="closeModal"> <FAIcon icon="fas fa-times" /> Hủy bỏ </el-button>
            <el-button type="primary" @click="onSubmitSendDocumentForm" :disabled="isSending"
              ><i class="fas fa-paper-plane"></i>
              {{ isSending ? "Đang gửi..." : "Gửi tài liệu" }}
            </el-button>
          </el-row>
        </el-form>
        <el-dialog width="60%" title="Các thư mục đã chia sẻ" :visible.sync="detailSharedTag" append-to-body>
          <el-table
            :data="orderedSharedTag.filter((data) => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%"
          >
            <el-table-column label="Email" prop="userEmail"> </el-table-column>
            <el-table-column label="Tên thư mục" prop="name"> </el-table-column>
            <el-table-column label="Quyền" align="center">
              <template slot-scope="scope">
                <el-tag
                  class="permission-tag"
                  :type="['default', 'success', 'info'][index % 3]"
                  v-for="(permission, index) in scope.row.permissions"
                  :key="permission"
                  size="small"
                >
                  {{ formatPermission(permission) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Type to search" :a="scope" />
              </template>
              <template slot-scope="scope">
                <el-button size="mini" type="danger" :foo="scope" @click="openUnshareConfirmDialog(scope.row)"
                  >Bỏ chia sẻ
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import ClickOutside from "vue-click-outside"
import { getEmailExistenceInfo } from "@/services/authentication_service"
import { getAllTagsByEmail, getTagInfo } from "@/services/tag_management_service"
import { apiShareDenyDocument, apiShareGrantDocument } from "@/services/document_management_service"
import FAIcon from "@/components/common/FAIcon.vue"
import ModalHeader from '@/components/common/ModalHeader.vue'

const _ = require("lodash")

export default {
  name: "DocumentSendModal",
  components: {ModalHeader, FAIcon },
  data: function () {
    return {
      show: false,
      fileList: [],
      email: "",
      isRealEmail: false,
      isStartCheck: false,
      folderName: "",
      optionsFolderName: [],
      loadingFolderName: false,
      description: "",
      permissions: [],
      isSending: false,
      params: {
        sortAscending: true,
        sortField: "name",
        page: 0,
        size: 2147483647,
      },
      detailSharedTag: false,
      search: null,
      id: null,
      document: {},
    }
  },
  methods: {
    showModal(document) {
      this.document = document
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async onSubmitSendDocumentForm() {
      this.isSending = true
      try {
        await apiShareGrantDocument(this.description, this.document.slug, this.folderName, this.email)
        this.$message({
          message: "Chia sẻ thành công",
          type: "success",
        })
        this.$emit("success")
      } catch (e) {
        this.$message({
          message: e.response.data.description || "Đã có lỗi xảy ra",
          type: "error",
        })
      }

      // Reset
      this.isSending = false
      this.isStartCheck = false
      this.isRealEmail = false
      this.email = ""
      this.description = ""
      this.show = false
      this.$store.dispatch("table/shouldReloadDocumentCurrent", {
        shouldReload: true,
        serverParams: this.serverParams,
      })
    },
    formatPermission(per) {
      switch (per) {
        case "READ":
          return "Đọc"
        case "VIEW":
          return "Xem"
        case "REPORT":
          return "Báo cáo"
        case "SHARE":
          return "Chia sẻ"
        case "COMMENT":
          return "Bình luận"
      }
    },
    startCheck() {
      this.isStartCheck = true
    },
    openUnshareConfirmDialog(tag) {
      console.log(tag)
      this.$confirm(`Tài liệu của bạn sẽ được xóa khỏi thư mục "${tag.name}".`, "Bạn có chắc chắn hủy chia sẻ?", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        try {
          await apiShareDenyDocument(this.description, this.document.slug, tag.id, tag.userEmail)

          this.$message({
            type: "success",
            message: "Đã hủy chia sẻ",
          })
          this.$emit("success")
        } catch (e) {
          this.$message({
            message: e.response.data.description,
            type: "error",
          })
        }
      })
    },
  },
  watch: {
    email: async function (val) {
      this.folderName = ""
      this.permissions = []

      // Check isRealEmail
      if (val === "") this.isStartCheck = false
      else {
        let resEmail = await getEmailExistenceInfo(val)

        if (resEmail == null) {
          this.$message({
            message: "Có lỗi xảy ra khi kiểm tra Email",
            type: "error",
          })
        } else {
          this.isRealEmail = resEmail
        }
      }

      if (this.isRealEmail) {
        // Load Folder Name
        this.loadingFolderName = true
        let resFolder = await getAllTagsByEmail(val, this.$data.params)
        /////////////

        if (resFolder != null) {
          resFolder = resFolder.data
          if (resFolder != null) {
            this.optionsFolderName = resFolder.map((item) => {
              return { label: item.name, value: item.id }
            })
          } else {
            this.optionsFolderName = null
          }
        } else {
          this.optionsFolderName = []
          this.$message({
            message: "Có lỗi xảy ra khi tải danh sách thư mục",
            type: "error",
          })
        }
        this.loadingFolderName = false
      } else {
        this.optionsFolderName = []
      }
    },
    folderName: async function (val) {
      if (val !== "") {
        let res = await getTagInfo(val)
        if (res == null) {
          this.$message({
            message: "Có lỗi xảy ra",
            type: "error",
          })
        } else {
          this.permissions = res.permissions
          this.description = res.description
        }
      }
    },
  },
  computed: {
    orderedSharedTag: function () {
      return _.take(_.orderBy(this.document.sharedTags, "name"), 3)
    },
  },
  directives: {
    ClickOutside,
  },
}
</script>

<style scoped>
.permission-tag {
  margin: 2px;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

label.el-form-item__label {
  font-size: 18px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.icon {
  color: darkslategrey;
  cursor: pointer;
}

.success-email-check-icn:before {
  color: green;
}

.error-email-check-icn:before {
  color: red;
}

.icn {
  color: lightseagreen;
  cursor: pointer;
}

.icn.disabled-icon {
  color: gray;
  opacity: 0.5;
  cursor: default;
}

.shared-tag-list {
  display: block;
  padding-left: 20px;
}

.shared-tag-list {
  display: block;
  padding-left: 20px;
}

.shared-tag {
  padding: 2px;
  margin: 5px 10px 5px 0px;
  font-size: 14px;
}

.document-title {
  font-size: 16px;
}

.disabled-icon {
  color: gray;
  opacity: 0.5;
  cursor: default;
}
</style>
